import { z } from 'zod';

export const myDataDocumentHeaderSchema = z.object({
  id: z.string(),
  documentNumber: z.number(),
  officialDate: z.string(),
  totalGross: z.number(),
  totalQuantity: z.number(),
  myDataMark: z.number().optional(),
  myDataSyncSuccess: z.boolean().optional(),
  myDataErrorMessage: z.string().optional(),
  myDataUuid: z.string().optional(),
  myDataQrCode: z.string().optional(),
  documentTypeName: z.string(),
  divisionName: z.string(),
  documentSeriesName: z.string(),
  traderName: z.string(),
  traderSiteName: z.string(),
});

export const getMyDataDocumentsSchema = z.array(myDataDocumentHeaderSchema);
